import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, PutEffect, select } from "redux-saga/effects";
import { clearString } from "../../../utils/functions";
import { automaticApi } from "../../../settings/api";
import { ReducersTypes } from "@/redux/reducers/Models";
import { jwtDecode } from "jwt-decode";

export interface Fetch {
    callback: (success: boolean, errorMessage?: string) => void;
}

export interface SendPinRegisterDeviceAction {
    type: string;
    payload: Fetch;
}

const getCustomer = (state: ReducersTypes) => state.customerReducer;

export default function* sendPinRegisterDevice({
    payload,
}: SendPinRegisterDeviceAction): Generator<
    CallEffect<unknown> | PutEffect<Action>,
    void,
    AxiosResponse
> {
    try {
        // @ts-expect-error
        const customer: ReducersTypes['customerReducer'] = yield select(getCustomer);

        const {
            NRC,
        }: {
            NRC: string;
        } = jwtDecode(customer?.refreshTokenTemporary!);

        const headers = {
            accesstoken: customer?.accessTokenTemporary,
            refreshtoken: customer?.refreshTokenTemporary,
            codigocliente: NRC,
        };

        const data = {
            actionId: 2020,
            cpf: clearString(customer?.username!),
        };

        const response = yield call(automaticApi.post, `/login-extended/v1/pin/sms`, data, { headers });

        if (response?.data?.status?.codigoRetorno === 0) {
            yield call(payload.callback, true);
        } else {
            yield call(payload.callback, false, "error");
        }

    } catch (error) {
        yield call(payload.callback, false, "timeout");
    }
}